import { List } from "@mantine/core";
import { useTranslation } from "react-i18next";

export const ProfessionalFeatures = () => {
    const { t } = useTranslation(["common"]);

    return (
        <List>
            <List.Item>{t("upgrade.pro.scan-limit")}</List.Item>
            <List.Item>{t("upgrade.pro.word-limit")}</List.Item>
            <List.Item>{t("upgrade.pro.ai-scan")}</List.Item>
            <List.Item>{t("upgrade.pro.follow-up-questions")}</List.Item>
            <List.Item>{t("upgrade.pro.fact-check")}</List.Item>
            <List.Item>{t("upgrade.pro.language-check")}</List.Item>
            <List.Item>{t("upgrade.pro.text-analysis")}</List.Item>
            <List.Item>{t("upgrade.pro.technical-terms")}</List.Item>
        </List>
    );
};
